import { Reducer } from 'redux';
import { GET_RATE_PLAN_PERIODS, RatePlanPeriodActionTypes, RatePlanPeriodState } from '../types/rateplanperiod.types';

const initialState: RatePlanPeriodState = {
  ratePlanPeriods: []
};

export const ratePlanPeriodReducer: Reducer<RatePlanPeriodState> = (
  state: RatePlanPeriodState = initialState, action
) => {
  switch ((action as RatePlanPeriodActionTypes).type) {
    case GET_RATE_PLAN_PERIODS:
      return {
        ratePlanPeriods: action.payload.page.content
      };
    default:
      return state;
  }
};
